<template>
  <div class="news" style="padding-top: 50px;">
    <img src="../../static/image/news_title.png" class="fullWidth" />
    <Row type="flex" justify="center" class="code-row-bg">
      <Col span="16">
        <div style="height: 100px;"></div>
        <div class="fontfaYahei color33 font36">“因为专注,所以专业”</div>
        <div style="height: 100px;" @mouseenter="clearNewsEnter()"></div>
        <Row type="flex" justify="center" class="code-row-bg">
          <Col
            span="4"
            class="alignCenter curP"
            style="padding-bottom: 10px;"
            v-for="(item,index) in newsList"
            :key="index"
          >
            <div
              :class="{indexActive:item.indexActive,indexActives:item.indexActives}"
              @mouseenter="newsEnter(index)"
              @click="clickNews(index)"
            >{{item.name}}</div>
          </Col>
        </Row>
        <div style="height: 50px;" @mouseenter="clearNewsEnter()"></div>
        <Row v-if="firstShow" type="flex" justify="center" class="code-row-bg">
          <!--<Col span="8" v-for="(item,index) in allList" :key="index">-->
          <Col span="24">
            <ul style="list-style: none">
              <li style="background: #EEEFF4">
                <router-link :to="{path:linkTo,query:{newId:new_title1_id}}">
                  <table class="fullWidth">
                    <tr>
                      <td width="40%">
                        <img :src="new_title1_icon" class="fullWidth" style="height: 225px;" />
                      </td>
                      <td style="height: 225px;position: relative;">
                        <div
                          class="fontfaYahei font24 color33 oneHang curP"
                          style="position: absolute;top: 20px;left: 30px;right: 0;height: 36px;"
                        >{{new_title1_title}}</div>

                        <div
                          class="fontfaYahei font14 color66 fiveHang"
                          style="position: absolute;top: 70px;left: 30px;right: 0;-webkit-box-orient: vertical;"
                          v-html="new_title1_intro"
                        ></div>
                        <div style="position: absolute;bottom:5px;left: 30px;right: 0;">
                          <table class="fullWidth">
                            <tr>
                              <td
                                width="100"
                                class="fontfaYahei font14 color99"
                              >{{new_title1_pv}}人已读</td>
                              <td
                                class="fontfaYahei font14 color99"
                                style="position: relative;padding-left: 25px;"
                              >
                                <Icon
                                  type="md-alarm"
                                  style="position: absolute;left: 0;top: 0;font-size: 20px;"
                                />
                                {{new_title1_time}}
                              </td>
                              <td width="100" align="right">
                                <router-link :to="{path:linkTo,query:{newId:new_title1_id}}">
                                  <span class="fontfaYahei font14 color99">查看更多>></span>
                                </router-link>
                              </td>
                            </tr>
                          </table>
                        </div>
                      </td>
                    </tr>
                  </table>
                </router-link>
              </li>
              <li style="height: 50px;"></li>
              <li
                style="padding: 40px 0;border-top: 1px solid #CCCCCC"
                v-for="(item,index) in firstList"
                :key="index"
              >
                <router-link :to="{path:linkTo,query:{newId:item.id}}">
                  <table class="fullWidth">
                    <tr>
                      <td width="30%">
                        <img :src="item.image" class="fullWidth" style="height: 225px;" />
                      </td>
                      <td style="height: 225px;position: relative;">
                        <div
                          class="fontfaYahei font24 color33 oneHang curP"
                          style="position: absolute;top: 0;left: 30px;right: 0;height: 36px;"
                        >{{item.title}}</div>
                        <div
                          class="fontfaYahei font14 color66 fiveHang"
                          style="position: absolute;top: 50px;left: 30px;right: 0;-webkit-box-orient: vertical;"
                        >{{item.intro}}</div>
                        <div style="position: absolute;bottom:5px;left: 30px;right: 0;">
                          <table class="fullWidth">
                            <tr>
                              <td width="100" class="fontfaYahei font14 color99">{{item.pv}}人已读</td>
                              <td
                                class="fontfaYahei font14 color99"
                                style="position: relative;padding-left: 25px;"
                              >
                                <Icon
                                  type="md-alarm"
                                  style="position: absolute;left: 0;top: 0;font-size: 20px;"
                                />
                                {{item.time}}
                              </td>
                              <td width="100" class="fontfaYahei font14 color99" align="right">
                                <router-link :to="{path:linkTo,query:{newId:item.id}}">
                                  <span class="fontfaYahei font14 color99">查看更多>></span>
                                </router-link>
                              </td>
                            </tr>
                          </table>
                        </div>
                      </td>
                    </tr>
                  </table>
                </router-link>
              </li>
            </ul>
          </Col>
        </Row>
        <Row v-if="secondShow" type="flex" justify="center" class="code-row-bg">
          <!--<Col span="8" v-for="(item,index) in allList" :key="index">-->
          <Col span="24">
            <ul style="list-style: none">
              <li style="background: #EEEFF4">
                <router-link :to="{path:linkTo,query:{newId:new_title2_id}}">
                  <table class="fullWidth">
                    <tr>
                      <td width="40%">
                        <img :src="new_title2_icon" class="fullWidth" style="height: 225px;" />
                      </td>
                      <td style="height: 225px;position: relative;">
                        <div
                          class="fontfaYahei font24 color33 oneHang curP"
                          style="position: absolute;top: 20px;left: 30px;right: 0;height: 36px;"
                        >{{new_title2_title}}</div>

                        <div
                          class="fontfaYahei font14 color66 fiveHang"
                          style="position: absolute;top: 70px;left: 30px;right: 0;-webkit-box-orient: vertical;"
                          v-html="new_title2_intro"
                        ></div>
                        <div style="position: absolute;bottom:5px;left: 30px;right: 0;">
                          <table class="fullWidth">
                            <tr>
                              <td
                                width="100"
                                class="fontfaYahei font14 color99"
                              >{{new_title2_pv}}人已读</td>
                              <td
                                class="fontfaYahei font14 color99"
                                style="position: relative;padding-left: 25px;"
                              >
                                <Icon
                                  type="md-alarm"
                                  style="position: absolute;left: 0;top: 0;font-size: 20px;"
                                />
                                {{new_title2_time}}
                              </td>
                              <td width="100" align="right">
                                <router-link :to="{path:linkTo,query:{newId:new_title2_id}}">
                                  <span class="fontfaYahei font14 color99">查看更多>></span>
                                </router-link>
                              </td>
                            </tr>
                          </table>
                        </div>
                      </td>
                    </tr>
                  </table>
                </router-link>
              </li>
              <li style="height: 50px;"></li>
              <li
                style="padding: 40px 0;border-top: 1px solid #CCCCCC"
                v-for="(item,index) in secondList"
                :key="index"
              >
                <router-link :to="{path:linkTo,query:{newId:item.id}}">
                  <table class="fullWidth">
                    <tr>
                      <td width="30%">
                        <img :src="item.image" class="fullWidth" style="height: 225px;" />
                      </td>
                      <td style="height: 225px;position: relative;">
                        <div
                          class="fontfaYahei font24 color33 oneHang curP"
                          style="position: absolute;top: 0;left: 30px;right: 0;height: 36px;"
                        >{{item.title}}</div>
                        <div
                          class="fontfaYahei font14 color66 fiveHang"
                          style="position: absolute;top: 50px;left: 30px;right: 0;-webkit-box-orient: vertical;"
                        >{{item.intro}}</div>
                        <div style="position: absolute;bottom:5px;left: 30px;right: 0;">
                          <table class="fullWidth">
                            <tr>
                              <td width="100" class="fontfaYahei font14 color99">{{item.pv}}人已读</td>
                              <td
                                class="fontfaYahei font14 color99"
                                style="position: relative;padding-left: 25px;"
                              >
                                <Icon
                                  type="md-alarm"
                                  style="position: absolute;left: 0;top: 0;font-size: 20px;"
                                />
                                {{item.time}}
                              </td>
                              <router-link :to="{path:linkTo,query:{newId:item.id}}">
                                <span class="fontfaYahei font14 color99">查看更多>></span>
                              </router-link>
                            </tr>
                          </table>
                        </div>
                      </td>
                    </tr>
                  </table>
                </router-link>
              </li>
            </ul>
          </Col>
        </Row>
      </Col>
    </Row>
    <div style="height: 80px;"></div>
    <Page
      :total="total"
      class="centerLR"
      :current.sync="draw"
      @on-change="changePage"
      :page-size="pageSize"
    />
    <div style="height: 50px;"></div>
    <xfck></xfck>
  </div>
</template>

<script>
import xfck from "./xfck.vue";

export default {
  name: "news",
  data() {
    return {
      pageSize: 5,
      total: 0,
      total1: 0,
      total2: 0,
      linkTo: "/newDetail",
      firstShow: true,
      page1: 1,
      secondShow: false,
      page12: 1,
      new_title1_icon: "",
      new_title1_title: "",
      new_title1_time: "",
      new_title1_intro: "",
      new_title1_pv: "",
      new_title1_id: "",
      new_title2_icon: "",
      new_title2_title: "",
      new_title2_time: "",
      new_title2_intro: "",
      new_title2_pv: "",
      new_title2_id: "",
      newsList: [
        {
          name: "行业新闻",
          indexActive: true,
          indexActives: true,
          val: "first"
        },
        {
          name: "简云课堂",
          indexActive: false,
          indexActives: false,
          val: "second"
        }
      ],
      firstList: [],
      secondList: [],
      isShowThis: 1,
      draw: 1,
      page: 1
    };
  },
  mounted() {
    this.getOne();
    this.getTwo();
  },
  methods: {
    getOne() {
      var that = this;
      var url = that.baseUrl + "/jianyunadmin/api.php?c=business_news_list";
      that.axios
        .get(url, { params: { region: 5, page: that.page } })
        .then(res => {
          that.new_title1_icon = that.getData.CDN_IMG + res.data.data[0].image;
          that.new_title1_title = res.data.data[0].title;
          that.new_title1_pv = res.data.data[0].pv;
          that.new_title1_intro = res.data.data[0].intro;
          that.new_title1_id = res.data.data[0].id;
          that.total1 = Number(res.data.cmd);
          that.total = that.total1;
          that.draw = that.page;
          that.new_title1_time = that.getData.timetrans(res.data.data[0].time);
          that.firstList = [];
          res.data.data.forEach(function(item, index) {
            if (index !== 0) {
              if (index < 4) {
                item.time = that.getData.timetrans(item.time);
                item.image = that.getData.CDN_IMG + item.image;
                that.firstList.push(item);
              }
            }
          });
        })
        .catch(error => {
          console.log(error);
        });
    },
    getTwo() {
      var that = this;
      var url = that.baseUrl + "/jianyunadmin/api.php?c=business_news_list";
      that.axios
        .get(url, { params: { region: 6, page: that.page } })
        .then(res => {
          that.new_title2_icon = that.getData.CDN_IMG + res.data.data[0].image;
          that.new_title2_title = res.data.data[0].title;
          that.new_title2_pv = res.data.data[0].pv;
          that.new_title2_intro = res.data.data[0].intro;
          that.new_title2_id = res.data.data[0].id;
          that.draw = that.page;
          that.total2 = Number(res.data.cmd);
          that.new_title2_time = that.getData.timetrans(res.data.data[0].time);
          that.secondList = [];
          res.data.data.forEach(function(item, index) {
            if (index !== 0) {
              if (index < 4) {
                item.time = that.getData.timetrans(item.time);
                item.image = that.getData.CDN_IMG + item.image;
                that.secondList.push(item);
              }
            }
          });
        })
        .catch(error => {
          console.log(error);
        });
    },
    newsEnter(index) {
      let that = this;
      that.newsList.map(function(item) {
        item.indexActive = false;
      });
      that.newsList[index].indexActive = true;
    },
    clickNews(index) {
      let that = this;
      that.newsList.map(function(item) {
        item.indexActive = false;
        item.indexActives = false;
      });
      that.newsList[index].indexActive = true;
      that.newsList[index].indexActives = true;
      that.page = 1;
      if (that.newsList[index].val === "first") {
        that.firstShow = true;
        that.secondShow = false;
        that.isShowThis = 1;
        that.total = that.total1;

        that.draw = that.page1;
      } else if (that.newsList[index].val === "second") {
        that.firstShow = false;
        that.secondShow = true;
        that.isShowThis = 2;
        that.total = that.total2;

        that.draw = that.page2;
      }
    },
    clearNewsEnter(index) {
      let that = this;
      that.newsList.map(function(item) {
        item.indexActive = false;
      });
    },
    changePage(e) {
      window.scrollTo(800, 800);
      var that = this;
      that.page = e;
      if (that.firstShow) {
        that.page1 = e;
        console.log(that.page1);
      } else {
        that.page2 = e;
        console.log(that.page2);
      }
      if (that.isShowThis === 1) {
        that.getOne();
      } else {
        that.getTwo();
      }
    }
  },
  components: {
    xfck
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/news.vue